import { Avatar } from "@mui/material";
import { Box } from "@mui/system";
import { getInitials } from "./cellUtils";

export type UserAvatarCellProps = {
  name: string;
};

export function UserAvatarCell({ name }: UserAvatarCellProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
      <Avatar
        sx={{
          width: 40,
          height: 40,
          fontSize: "14px",
          bgcolor: "primary.main",
        }}
      >
        {getInitials(name)}
      </Avatar>
    </Box>
  );
}
